import { default as chainmailLayer1 } from 'mc-assets/dist/other-textures/latest/models/armor/chainmail_layer_1.png'
import { default as chainmailLayer2 } from 'mc-assets/dist/other-textures/latest/models/armor/chainmail_layer_2.png'
import { default as diamondLayer1 } from 'mc-assets/dist/other-textures/latest/models/armor/diamond_layer_1.png'
import { default as diamondLayer2 } from 'mc-assets/dist/other-textures/latest/models/armor/diamond_layer_2.png'
import { default as goldenLayer1 } from 'mc-assets/dist/other-textures/latest/models/armor/gold_layer_1.png'
import { default as goldenLayer2 } from 'mc-assets/dist/other-textures/latest/models/armor/gold_layer_2.png'
import { default as ironLayer1 } from 'mc-assets/dist/other-textures/latest/models/armor/iron_layer_1.png'
import { default as ironLayer2 } from 'mc-assets/dist/other-textures/latest/models/armor/iron_layer_2.png'
import { default as leatherLayer1 } from 'mc-assets/dist/other-textures/latest/models/armor/leather_layer_1.png'
import { default as leatherLayer1Overlay } from 'mc-assets/dist/other-textures/latest/models/armor/leather_layer_1_overlay.png'
import { default as leatherLayer2 } from 'mc-assets/dist/other-textures/latest/models/armor/leather_layer_2.png'
import { default as leatherLayer2Overlay } from 'mc-assets/dist/other-textures/latest/models/armor/leather_layer_2_overlay.png'
import { default as netheriteLayer1 } from 'mc-assets/dist/other-textures/latest/models/armor/netherite_layer_1.png'
import { default as netheriteLayer2 } from 'mc-assets/dist/other-textures/latest/models/armor/netherite_layer_2.png'
import { default as turtleLayer1 } from 'mc-assets/dist/other-textures/latest/models/armor/turtle_layer_1.png'

export { default as armorModel } from './armorModels.json'

export const armorTextures = {
  'leather_layer_1': leatherLayer1,
  'leather_layer_1_overlay': leatherLayer1Overlay,
  'leather_layer_2': leatherLayer2,
  'leather_layer_2_overlay': leatherLayer2Overlay,
  'chainmail_layer_1': chainmailLayer1,
  'chainmail_layer_2': chainmailLayer2,
  'iron_layer_1': ironLayer1,
  'iron_layer_2': ironLayer2,
  'diamond_layer_1': diamondLayer1,
  'diamond_layer_2': diamondLayer2,
  'golden_layer_1': goldenLayer1,
  'golden_layer_2': goldenLayer2,
  'netherite_layer_1': netheriteLayer1,
  'netherite_layer_2': netheriteLayer2,
  'turtle_layer_1': turtleLayer1
}
